<template>
  <div class="flex flex-row bg-PRIMARY rounded-lg w-full p-3 gap-3">
    <div
      class="relative flex flex-col justify-center items-center bg-NAVY-BLUE px-2 pb-4 pt-5 rounded-lg"
    >
      <PirateFigure :image-url="imageUrl" class="!w-[54px] !h-[69px]" black-shadow></PirateFigure>
      <div v-if="props.level === undefined || props.level === 0" class="z-10 absolute right-1 top-1">
        <img src="@/assets/icons/lock.svg" class="w-5 h-5 object-contain" />
      </div>
      <div v-else class="absolute top-2 right-2 border border-white bg-LIGHTGREY rounded-md z-10">
        <p class="text-xs font-semibold text-PRIMARY px-[3px] py-[1px]">
          Lv.{{ props.level }}
        </p>
      </div>
    </div>

    <div class="flex flex-col items-start justify-between w-full">
      <div class="flex flex-col gap-2 items-start">
        <p class="text-xs font-semibold">{{ props.name }}</p>
        <p class="text-xs font-normal text-justify">
          {{ props.description }}
        </p>
      </div>

      <div class="flex flex-row justify-between items-end w-full">
        <div class="flex flex-col gap-0.5">
          <p class="text-[10px] text-GREY">Profit per hour</p>
          <div class="flex flex-row gap-1">
            <img src="../assets/icons/token-2.svg" class="w-4 h-4" />
            <p class="text-[10px]">+{{ props.profit }}</p>
          </div>
        </div>
        <pow-button tertiary size="xs" class="min-w-[110px] h-8" @click="emit('buttonClick')">
          <p v-if="props.isMax" class="font-normal text-xs opacity-25">Max Level</p>
          <div v-else class="flex flex-row gap-1">
            <img src="../assets/icons/token-2.svg" class="w-4 h-4" />
            <p class="font-normal text-xs">{{ props.price }} / {{ props.level ? 'Upgrade' : 'Buy' }}</p>
          </div>
        </pow-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import PowButton from './PowButton.vue'
import PirateFigure from './PirateFigure.vue'
import { computed } from 'vue'
const props = defineProps({
  name: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  image: {
    type: String,
    required: true
  },
  profit: {
    type: Number,
    required: true
  },
  level: {
    type: Number,
    required: false
  },
  price: {
    type: Number,
    required: true
  },
  isMax: {
    type: Boolean,
    required: false,
    default: false
  }
})

const emit = defineEmits(['buttonClick'])
const imageUrl = computed(() => new URL(`../assets/images/${props.image}`, import.meta.url).href)
</script>

<style setup></style>
